import { useMemo, useState, useEffect} from "react";
import { useGroupChatContext } from "../../context/groupchatContext";
import { useGetRecentChatsQuery, useLazyGetRecentChatsQuery } from "../../services/chatService";
import React from "react";
import ChatThreadListing from "./chatThreadListing";

const RECENT_CHAT_REFRESH_INTERVAL = 5 * 60 * 1000;

export default function PatientChatThread(){

    const groupChatContext = useGroupChatContext();
    const {selectedLocations, chatFilter, selectedChatTab} = useMemo(() => ({
        selectedLocations: groupChatContext.selectedLocations,
        chatFilter: groupChatContext.chatFilter,
        selectedChatTab: groupChatContext.selectedChatTab
    }));

    const [pagination, setPagination] = useState({limit: 10, page: 1});
    const [chatApiParams, setChatApiParams] = useState({ location_id: selectedLocations, ...pagination, last_chat_id: '', unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only, unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention, attachment: chatFilter.attachment });

    const {
        data: patientChats, isLoading
    } = useGetRecentChatsQuery({...chatApiParams}, {refetchOnMountOrArgChange: true });
    const [refreshRecentChats] = useLazyGetRecentChatsQuery();


    useEffect(()=>{
        let chatThreadsLength = patientChats?.data?.length;
        let lastChat = {}
        if(chatThreadsLength){
            lastChat = patientChats?.data[chatThreadsLength-1];
        }
        setChatApiParams({location_id: selectedLocations, ...pagination, last_chat_id: pagination.page == 1 ? '' : lastChat.chat_id, unread_only: chatFilter.unread_only, urgent: chatFilter.urgent_only, unacknowledged: chatFilter.unacknowledged, mention: chatFilter.mention, attachment: chatFilter.attachment})
    }, [pagination])

    useEffect(()=>{
        setPagination({...pagination, page: 1});
    }, [selectedLocations, chatFilter, selectedChatTab])

    useEffect(() => {
        const refreshChatApiParams = {
            location_id: selectedLocations,
            limit: 10,
            page: 1,
            last_chat_id: '',
            unread_only: chatFilter.unread_only,
            urgent: chatFilter.urgent_only,
            unacknowledged: chatFilter.unacknowledged,
            mention: chatFilter.mention,
            attachment: chatFilter.attachment,
        };

        const refreshChats = () => {
            refreshRecentChats(refreshChatApiParams)
                .unwrap()
                .catch(() => {});
        };

        const refreshInterval = setInterval(refreshChats, RECENT_CHAT_REFRESH_INTERVAL);

        return () => {
            clearInterval(refreshInterval);
        };
    }, [selectedLocations, chatFilter, refreshRecentChats])


    const fetchMoreChats = () => {
        setPagination({...pagination, page: ++pagination.page})
    }

    return(
        <div>
            <ChatThreadListing chatThreadsData={patientChats} fetchMoreChats={fetchMoreChats} isLoadingData={isLoading} pagination={pagination} />
        </div>
    )
}